module.exports = __webpack_public_path__ + "img/chipcard-logo.201cd1b0.png";